<div class="btn-toolbar dropup">
    <div class="btn-group" [sq-action-buttons]="{items: [action]}"></div>
</div>